<template>
  <svg width="32px" height="30px" viewBox="0 0 32 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="✅-16-Mobile-Landingpages-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="T_12.4-Warning-Page" transform="translate(-368.000000, -124.000000)" fill="currentColor">
            <g id="Group-2" transform="translate(230.000000, 120.000000)">
                <g id="Tools-/-Technology-/-devices-/-24" transform="translate(136.000000, 0.000000)">
                    <path d="M11.25,33.75 L4.5,33.75 C3.25735931,33.75 2.25,32.7426407 2.25,31.5 L2.25,18 C2.25,16.7573593 3.25735931,15.75 4.5,15.75 L11.25,15.75 C12.4926407,15.75 13.5,16.7573593 13.5,18 L13.5,31.5 C13.5,32.7426407 12.4926407,33.75 11.25,33.75 Z M4.5,18 L4.5,31.5 L11.25,31.5 L11.25,18 L4.5,18 Z M31.5,4.5 L6.75,4.5 C5.50735931,4.5 4.5,5.50735931 4.5,6.75 L4.5,13.5 L6.75,13.5 L6.75,6.75 L31.5,6.75 L31.5,22.5 L15.75,22.5 L15.75,24.75 L18,24.75 L18,29.25 L15.75,29.25 L15.75,31.5 L25.875,31.5 L25.875,29.25 L20.25,29.25 L20.25,24.75 L31.5,24.75 C32.7426407,24.75 33.75,23.7426407 33.75,22.5 L33.75,6.75 C33.75,5.50735931 32.7426407,4.5 31.5,4.5 Z" id="Fill"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  name: 'Devices'
};
</script>
